module.exports = __webpack_public_path__ + "media/images/webpage/shared/checklist/fair-84c2d7bc572aff8299e7d2d7d8037550.svg";